/* Spin and win: one random spin per visitor, weighted by the chances set in the theme editor. */
(function () {
  'use strict';
  var KEY = 'safara-spin-v1';

  function arc(a0, a1) {
    function pt(a) { var r = (a - 90) * Math.PI / 180; return (97 * Math.cos(r)).toFixed(2) + ' ' + (97 * Math.sin(r)).toFixed(2); }
    return 'M0 0 L' + pt(a0) + ' A97 97 0 ' + (a1 - a0 > 180 ? 1 : 0) + ' 1 ' + pt(a1) + ' Z';
  }
  function label(t, text) {
    var words = text.split(' '), lines = [''];
    words.forEach(function (w) { var l = lines[lines.length - 1]; if ((l + ' ' + w).trim().length > 12 && l) lines.push(w); else lines[lines.length - 1] = (l + ' ' + w).trim(); });
    lines.forEach(function (l, i) {
      var s = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
      s.setAttribute('x', '0'); s.setAttribute('dy', i ? '12' : String(-(lines.length - 1) * 6)); s.textContent = l; t.appendChild(s);
    });
  }
  function read() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var prizes = [];
    try { prizes = JSON.parse(root.querySelector('[data-spin-prizes]').textContent); } catch (e) { return; }
    if (!prizes.length) return;
    var dialog = root.querySelector('[data-spin-dialog]'), wheel = root.querySelector('[data-spin-wheel]');
    var go = root.querySelector('[data-spin-go]'), result = root.querySelector('[data-spin-result]');
    var opener = root.querySelector('[data-spin-open]'), lastFocus = null;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.querySelectorAll('[data-arc]').forEach(function (p) { var a = p.getAttribute('data-arc').split(','); p.setAttribute('d', arc(+a[0], +a[1])); });
    root.querySelectorAll('[data-spin-text]').forEach(function (t) { label(t, t.getAttribute('data-spin-text')); });

    function slice(id) { return root.querySelector('[data-spin-slice="' + id + '"]'); }
    function show(p) {
      root.classList.add('is-done');
      go.hidden = true;
      result.hidden = false;
      root.querySelector('[data-spin-result-title]').textContent = p.label;
      root.querySelector('[data-spin-result-note]').textContent = p.note || '';
      var wrap = root.querySelector('[data-spin-code-wrap]');
      wrap.hidden = !p.code;
      root.querySelector('[data-spin-code]').textContent = p.code || '';
      var shop = root.querySelector('[data-spin-shop]');
      if (!shop.dataset.base) shop.dataset.base = shop.getAttribute('href');
      shop.setAttribute('href', p.link || shop.dataset.base);
      shop.hidden = !p.code;
    }
    function turnTo(p, turns) {
      var s = slice(p.id), from = +s.getAttribute('data-from'), to = +s.getAttribute('data-to');
      var inside = from + (to - from) * (.25 + Math.random() * .5);
      return turns * 360 + (360 - inside);
    }

    var saved = read();
    if (saved) {
      var sp = prizes.filter(function (p) { return p.id === saved.id; })[0];
      if (sp) { wheel.style.transform = 'rotate(' + turnTo(sp, 0) + 'deg)'; show(sp); }
    }

    function open() {
      lastFocus = document.activeElement;
      dialog.hidden = false; document.documentElement.style.overflow = 'hidden';
      (go.hidden ? dialog.querySelector('.spin__copy, .spin__close') : go).focus();
    }
    function close() {
      dialog.hidden = true; document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus(); else opener.focus();
    }
    opener.addEventListener('click', open);
    root.querySelectorAll('[data-spin-close]').forEach(function (b) { b.addEventListener('click', close); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(dialog.querySelectorAll('button:not([hidden]), a[href]:not([hidden])')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    go.addEventListener('click', function () {
      if (read()) return;
      var w = prizes.map(function (p) { return Math.max(0, +p.weight || 0); });
      var total = w.reduce(function (t, x) { return t + x; }, 0);
      if (!total) { w = prizes.map(function () { return 1; }); total = prizes.length; }
      var r = Math.random() * total, pick = prizes[prizes.length - 1];
      for (var i = 0; i < prizes.length; i++) { r -= w[i]; if (r < 0) { pick = prizes[i]; break; } }
      save({ id: pick.id, at: Date.now() });
      go.disabled = true;
      var deg = turnTo(pick, still ? 1 : 6), ms = still ? 400 : 4600;
      wheel.style.transition = 'transform ' + ms + 'ms cubic-bezier(.12,.68,.12,1)';
      wheel.style.transform = 'rotate(' + deg + 'deg)';
      setTimeout(function () { show(pick); var c = dialog.querySelector('.spin__copy'); if (pick.code && c) c.focus(); else dialog.querySelector('.spin__close').focus(); }, ms + 150);
    });

    var copy = root.querySelector('[data-spin-copy]');
    copy.addEventListener('click', function () {
      var code = root.querySelector('[data-spin-code]').textContent;
      function done() { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy code'; }, 2000); }
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, function () {});
    });
  }

  function boot() { document.querySelectorAll('[data-spin]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
